<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Employee Incentive Level</h4>
  </div>

  <div class="card-body mt-2">
    <form @submit.prevent="storeContact(employeeIncentiveSetups)">
      <div class="row">
        <div class="col-sm-6 offset-md-3 col-12">
          <div class="row"  v-for="(data, index) in employeeIncentiveSetups">
            <div class="col-12">
              <div class="mb-1">
                <label class="col-form-label">Incentive Setup</label>
                <v-select
                    placeholder="Select Incentive Level"
                    v-model="data.incentive_setup_id"
                    :options="incentiveSetupList"
                    label="name"
                />
              </div>
            </div>

            <div class="col-sm-6 offset-sm-3">
              <button type="submit" class="btn btn-primary me-1">Submit</button>
              <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script setup>
import {defineProps, onMounted, ref, watch} from "vue";
import {useRoute} from "vue-router";
import handleHospital from "@/services/modules/hospital";

const emit = defineEmits(['storeContact'])
const props = defineProps({
  items: {
    type: Array
  }
})

const route = useRoute()

let incentiveSetupList = ref([])
const { fetchIncentiveSetupList } = handleHospital()

const employeeIncentiveSetups  = ref([
    {
      incentive_setup_id: '',
    }
])

const storeContact = (data) => {
  let items = data.map(item => ({
    incentive_setup_id: item.incentive_setup_id ? item.incentive_setup_id.id : null,
  }));
  emit('storeContact', {'items':items})
}

const reset = () => {
  employeeIncentiveSetups.value.length = 0;
}

watch(
    [() => props.items, () => incentiveSetupList.value],
    ([items, setupList]) => {
      if (items.length && setupList.length) {
        formDataSet();
      }
    },
    { immediate: true }
);

const getIncentiveSetupList = async () => {
  let query = `?company_id=${route.params.companyId}`;
  query += '&is_all=true&incentive_type=level'
  incentiveSetupList.value = []

  await fetchIncentiveSetupList(query).then(res => {
    if (!res.status){
      return
    }
    incentiveSetupList.value = res.data;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
  })
}

const formDataSet = () => {
    if (props.items.length){
      employeeIncentiveSetups.value = props.items.map(item => {
        const selected = incentiveSetupList.value.find(i => Number(i.id) === Number(item.incentive_setup_id));
        return {
          ...item,
          incentive_setup_id: selected || null
        };
      });
    }
}

onMounted(() => {
  Promise.all([
    getIncentiveSetupList()
  ])
})

</script>
